// Shared brand data — single source of truth for both apps. Generated/maintained;
// edit here, not the per-app overlays. APP_BUNDLES carries exam_name/exam_code (mobile
// reads them; web ignores). See docs/app-constant-usage-audit.md.
export const APP_BUNDLES = [
    {
        title: 'CISSP',
        key: 'cissp',
        description: 'Certified Information Systems Security Professional',
        exam_name: 'CISSP',
        exam_code: '',
        bundle_firebase_collection_name: 'CISSP',
    },
    {
        title: 'CCSP',
        key: 'ccsp',
        description: 'Certified Cloud Security Professional',
        exam_name: 'CCSP',
        exam_code: '',
        bundle_firebase_collection_name: 'CCSP',
    },
    {
        title: 'SSCP',
        key: 'sscp',
        description: 'Systems Security Certified Practitioner',
        exam_name: 'SSCP',
        exam_code: '',
        bundle_firebase_collection_name: 'SSCP',
    },
    {
        title: 'CC',
        key: 'cc',
        description: 'Certified in Cybersecurity',
        exam_name: 'CC',
        exam_code: '',
        bundle_firebase_collection_name: 'CC',
    },
]

export const EXAM_TITLES = {
  'cissp': 'CISSP',
  'ccsp': 'CCSP',
  'sscp': 'SSCP',
  'cc': 'CC',
}

export const BUNDLE_APP_NAME = "ISC2_BUNDLE";

export const IS_BUNDLE_APP = true;

// Paywall headline (two lines; line2 is the accent line). Shared by web + mobile
// so both surfaces render one headline. Consumed via @learnzapp/core/pricing
// resolveHeadline, which fills a fallback if either line is blank.
export const PAYWALL_COPY = {
    headline: {
        line1: 'Everything You Need to',
        line2: 'Pass ISC2',
    },
};
